export default {
  data() {
    return {
      mobileDropdown: [
        {
          title: this.$t("dropdowns.sortingDirection"),
          options: [
            {
              label: this.$t("dropdowns.asc"),
              key: "ASC",
              method: () => {
                this.sortProjects(this.teamsSettings[this.$route.params.team].listsSettings.projects.order.col, "ASC");
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("dropdowns.desc"),
              key: "DESC",
              method: () => {
                this.sortProjects(this.teamsSettings[this.$route.params.team].listsSettings.projects.order.col, "DESC");
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
          ],
        },
        {
          title: this.$t("dropdowns.sortingBy"),
          options: [
            {
              label: this.$t("project.title"),
              key: "title",
              method: () => {
                this.sortProjects(
                  "title",
                  this.teamsSettings[this.$route.params.team].listsSettings.projects.order.dir
                );
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("project.lastActivity"),
              key: "last_active_at",
              method: () => {
                this.sortProjects(
                  "last_active_at",
                  this.teamsSettings[this.$route.params.team].listsSettings.projects.order.dir
                );
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("project.updated"),
              key: "updated_at",
              method: () => {
                this.sortProjects(
                  "updated_at",
                  this.teamsSettings[this.$route.params.team].listsSettings.projects.order.dir
                );
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("project.created"),
              key: "created_at",
              method: () => {
                this.sortProjects(
                  "created_at",
                  this.teamsSettings[this.$route.params.team].listsSettings.projects.order.dir
                );
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
          ],
        },
      ],
      sortMainColDropdown: [
        {
          title: this.$t("dropdowns.sortingDirection"),
          key: "title",
          options: [
            {
              label: this.$t("dropdowns.asc"),
              key: "ASC",
              method: () => {
                this.sortProjects("title", "ASC");
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("dropdowns.desc"),
              key: "DESC",
              method: () => {
                this.sortProjects("title", "DESC");
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
          ],
        },
      ],
      showAsFirstColDropdown: [
        {
          title: this.$t("dropdowns.sortingDirection"),
          disabled: false,
          options: [
            {
              label: this.$t("dropdowns.asc"),
              key: "ASC",
              method: () => {
                this.sortProjects(
                  this.teamsSettings[this.$route.params.team].listsSettings.projects.showAs.firstCol.key,
                  "ASC"
                );
              },
              icon: "Icon=check.svg",
              hoverBg: true,
              disabled: false,
            },
            {
              label: this.$t("dropdowns.desc"),
              key: "DESC",
              method: () => {
                this.sortProjects(
                  this.teamsSettings[this.$route.params.team].listsSettings.projects.showAs.firstCol.key,
                  "DESC"
                );
              },
              icon: "Icon=check.svg",
              hoverBg: true,
              disabled: false,
            },
          ],
        },
        {
          title: this.$t("dropdowns.showAs"),
          options: [
            {
              label: this.$t("project.client"),
              key: "owner",
              method: () => {
                this.changeCol({
                  list: "projects",
                  showAs: {
                    firstCol: {
                      label: "project.client",
                      key: "owner",
                      format: "owner",
                      size: 2,
                      sortable: false,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("project.contact"),
              key: "contact",
              method: () => {
                this.changeCol({
                  list: "projects",
                  showAs: {
                    firstCol: {
                      label: "project.contact",
                      key: "contact",
                      format: "name",
                      size: 2,
                      sortable: false,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("project.status"),
              key: "status",
              method: () => {
                this.changeCol({
                  list: "projects",
                  showAs: {
                    firstCol: {
                      label: "project.status",
                      key: "status",
                      format: "projectStatus",
                      size: 1,
                      sortable: false,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("project.pwProtected"),
              key: "private",
              method: () => {
                this.changeCol({
                  list: "projects",
                  showAs: {
                    firstCol: {
                      label: "project.password",
                      key: "private",
                      format: "pwProtected",
                      size: 1,
                      sortable: false,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("project.notes"),
              key: "notes",
              method: () => {
                this.changeCol({
                  list: "projects",
                  showAs: {
                    firstCol: {
                      label: "project.notes",
                      key: "notes",
                      format: "none",
                      size: 2,
                      sortable: false,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("project.template"),
              key: "template",
              method: () => {
                this.changeCol({
                  list: "projects",
                  showAs: {
                    firstCol: {
                      label: "project.template",
                      key: "template",
                      format: "template",
                      size: 2,
                      sortable: false,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("project.lastActivity"),
              key: "last_active_at",
              method: () => {
                this.changeCol({
                  list: "projects",
                  showAs: {
                    firstCol: {
                      label: "project.lastActivity",
                      key: "last_active_at",
                      format: "date",
                      size: 2,
                      sortable: true,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("project.reactionTime"),
              key: "reaction_time",
              method: () => {
                this.changeCol({
                  list: "projects",
                  showAs: {
                    firstCol: {
                      label: "project.reactionTime",
                      key: "reaction_time",
                      format: "secondsToTime",
                      size: 2,
                      sortable: true,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("project.updated"),
              key: "updated_at",
              method: () => {
                this.changeCol({
                  list: "projects",
                  showAs: {
                    firstCol: {
                      label: "project.updated",
                      key: "updated_at",
                      format: "date",
                      size: 2,
                      sortable: true,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("project.created"),
              key: "created_at",
              method: () => {
                this.changeCol({
                  list: "projects",
                  showAs: {
                    firstCol: {
                      label: "project.created",
                      key: "created_at",
                      format: "date",
                      size: 2,
                      sortable: true,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("project.archived"),
              key: "archived",
              method: () => {
                this.changeCol({
                  list: "projects",
                  showAs: {
                    firstCol: {
                      label: "project.archived",
                      key: "status",
                      format: "archived",
                      size: 2,
                      sortable: false,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
          ],
        },
      ],
      showAsSecondColDropdown: [
        {
          title: this.$t("dropdowns.sortingDirection"),
          disabled: false,
          options: [
            {
              label: this.$t("dropdowns.asc"),
              key: "ASC",
              method: () => {
                this.sortProjects(
                  this.teamsSettings[this.$route.params.team].listsSettings.projects.showAs.secondCol.key,
                  "ASC"
                );
              },
              icon: "Icon=check.svg",
              hoverBg: true,
              disabled: false,
            },
            {
              label: this.$t("dropdowns.desc"),
              key: "DESC",
              method: () => {
                this.sortProjects(
                  this.teamsSettings[this.$route.params.team].listsSettings.projects.showAs.secondCol.key,
                  "DESC"
                );
              },
              icon: "Icon=check.svg",
              hoverBg: true,
              disabled: false,
            },
          ],
        },
        {
          title: this.$t("dropdowns.showAs"),
          options: [
            {
              label: this.$t("project.client"),
              key: "owner",
              method: () => {
                this.changeCol({
                  list: "projects",
                  showAs: {
                    secondCol: {
                      label: "project.client",
                      key: "owner",
                      format: "owner",
                      size: 2,
                      sortable: false,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("project.contact"),
              key: "contact",
              method: () => {
                this.changeCol({
                  list: "projects",
                  showAs: {
                    secondCol: {
                      label: "project.contact",
                      key: "contact",
                      format: "name",
                      size: 2,
                      sortable: false,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("project.status"),
              key: "status",
              method: () => {
                this.changeCol({
                  list: "projects",
                  showAs: {
                    secondCol: {
                      label: "project.status",
                      key: "status",
                      format: "projectStatus",
                      size: 1,
                      sortable: false,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("project.pwProtected"),
              key: "private",
              method: () => {
                this.changeCol({
                  list: "projects",
                  showAs: {
                    secondCol: {
                      label: "project.password",
                      key: "private",
                      format: "pwProtected",
                      size: 1,
                      sortable: false,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("project.notes"),
              key: "notes",
              method: () => {
                this.changeCol({
                  list: "projects",
                  showAs: {
                    secondCol: {
                      label: "project.notes",
                      key: "notes",
                      format: "none",
                      size: 2,
                      sortable: false,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("project.template"),
              key: "template",
              method: () => {
                this.changeCol({
                  list: "projects",
                  showAs: {
                    secondCol: {
                      label: "project.template",
                      key: "template",
                      format: "template",
                      size: 2,
                      sortable: false,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("project.lastActivity"),
              key: "last_active_at",
              method: () => {
                this.changeCol({
                  list: "projects",
                  showAs: {
                    secondCol: {
                      label: "project.lastActivity",
                      key: "last_active_at",
                      format: "date",
                      size: 2,
                      sortable: true,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("project.reactionTime"),
              key: "reaction_time",
              method: () => {
                this.changeCol({
                  list: "projects",
                  showAs: {
                    secondCol: {
                      label: "project.reactionTime",
                      key: "reaction_time",
                      format: "secondsToTime",
                      size: 2,
                      sortable: true,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("project.updated"),
              key: "updated_at",
              method: () => {
                this.changeCol({
                  list: "projects",
                  showAs: {
                    secondCol: {
                      label: "project.updated",
                      key: "updated_at",
                      format: "date",
                      size: 2,
                      sortable: true,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("project.created"),
              key: "created_at",
              method: () => {
                this.changeCol({
                  list: "projects",
                  showAs: {
                    secondCol: {
                      label: "project.created",
                      key: "created_at",
                      format: "date",
                      size: 2,
                      sortable: true,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("project.archived"),
              key: "archived",
              method: () => {
                this.changeCol({
                  list: "projects",
                  showAs: {
                    secondCol: {
                      label: "project.archived",
                      key: "status",
                      format: "archived",
                      size: 2,
                      sortable: false,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
          ],
        },
      ],
      showAsThirdColDropdown: [
        {
          title: this.$t("dropdowns.sortingDirection"),
          disabled: false,
          options: [
            {
              label: this.$t("dropdowns.asc"),
              key: "ASC",
              method: () => {
                this.sortProjects(
                  this.teamsSettings[this.$route.params.team].listsSettings.projects.showAs.thirdCol.key,
                  "ASC"
                );
              },
              icon: "Icon=check.svg",
              hoverBg: true,
              disabled: false,
            },
            {
              label: this.$t("dropdowns.desc"),
              key: "DESC",
              method: () => {
                this.sortProjects(
                  this.teamsSettings[this.$route.params.team].listsSettings.projects.showAs.thirdCol.key,
                  "DESC"
                );
              },
              icon: "Icon=check.svg",
              hoverBg: true,
              disabled: false,
            },
          ],
        },
        {
          title: this.$t("dropdowns.showAs"),
          options: [
            {
              label: this.$t("project.client"),
              key: "owner",
              method: () => {
                this.changeCol({
                  list: "projects",
                  showAs: {
                    thirdCol: {
                      label: "project.client",
                      key: "owner",
                      format: "owner",
                      size: 2,
                      sortable: false,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("project.contact"),
              key: "contact",
              method: () => {
                this.changeCol({
                  list: "projects",
                  showAs: {
                    thirdCol: {
                      label: "project.contact",
                      key: "contact",
                      format: "name",
                      size: 2,
                      sortable: false,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("project.status"),
              key: "status",
              method: () => {
                this.changeCol({
                  list: "projects",
                  showAs: {
                    thirdCol: {
                      label: "project.status",
                      key: "status",
                      format: "projectStatus",
                      size: 1,
                      sortable: false,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("project.pwProtected"),
              key: "private",
              method: () => {
                this.changeCol({
                  list: "projects",
                  showAs: {
                    thirdCol: {
                      label: "project.password",
                      key: "private",
                      format: "pwProtected",
                      size: 1,
                      sortable: false,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("project.notes"),
              key: "notes",
              method: () => {
                this.changeCol({
                  list: "projects",
                  showAs: {
                    thirdCol: {
                      label: "project.notes",
                      key: "notes",
                      format: "none",
                      size: 2,
                      sortable: false,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("project.template"),
              key: "template",
              method: () => {
                this.changeCol({
                  list: "projects",
                  showAs: {
                    thirdCol: {
                      label: "project.template",
                      key: "template",
                      format: "template",
                      size: 2,
                      sortable: false,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("project.lastActivity"),
              key: "last_active_at",
              method: () => {
                this.changeCol({
                  list: "projects",
                  showAs: {
                    thirdCol: {
                      label: "project.lastActivity",
                      key: "last_active_at",
                      format: "date",
                      size: 2,
                      sortable: true,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("project.reactionTime"),
              key: "reaction_time",
              method: () => {
                this.changeCol({
                  list: "projects",
                  showAs: {
                    thirdCol: {
                      label: "project.reactionTime",
                      key: "reaction_time",
                      format: "secondsToTime",
                      size: 2,
                      sortable: true,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("project.updated"),
              key: "updated_at",
              method: () => {
                this.changeCol({
                  list: "projects",
                  showAs: {
                    thirdCol: {
                      label: "project.updated",
                      key: "updated_at",
                      format: "date",
                      size: 2,
                      sortable: true,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("project.created"),
              key: "created_at",
              method: () => {
                this.changeCol({
                  list: "projects",
                  showAs: {
                    thirdCol: {
                      label: "project.created",
                      key: "created_at",
                      format: "date",
                      size: 2,
                      sortable: true,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("project.archived"),
              key: "archived",
              method: () => {
                this.changeCol({
                  list: "projects",
                  showAs: {
                    thirdCol: {
                      label: "project.archived",
                      key: "status",
                      format: "archived",
                      size: 2,
                      sortable: false,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
          ],
        },
      ],
      filterDropdown: [
        {
          title: this.$t("filters.filterProjects"),
          options: [
            {
              label: this.$t("filters.myProjects"),
              column: 1,
              switch: {
                name: "is_mine",
                model: true,
              },
              checkbox: true,
              method: () => {},
              hoverBg: true,
            },
            {
              label: this.$t("filters.isSend"),
              column: 1,
              switch: {
                name: "is_posted",
                model: true,
              },
              checkbox: true,
              method: () => {},
              hoverBg: true,
            },
            {
              label: this.$t("filters.isVisited"),
              column: 1,
              switch: {
                name: "is_visited",
                model: true,
              },
              method: () => {},
              checkbox: true,
              hoverBg: true,
            },
            {
              label: this.$t("filters.isPrivate"),
              column: 1,
              switch: {
                name: "is_private",
                model: true,
              },
              method: () => {},
              checkbox: true,
              hoverBg: true,
            },
            {
              label: this.$t("filters.hasUploads"),
              column: 1,
              switch: {
                name: "has_uploads",
                model: true,
              },
              method: () => {},
              checkbox: true,
              hoverBg: true,
            },
            {
              label: this.$t("filters.hasMessages"),
              column: 1,
              switch: {
                name: "has_messages",
                model: true,
              },
              method: () => {},
              checkbox: true,
              hoverBg: true,
            },
            {
              label: this.$t("filters.hasDownloads"),
              column: 1,
              switch: {
                name: "has_downloads",
                model: true,
              },
              method: () => {},
              checkbox: true,
              hoverBg: true,
            },
            {
              label: this.$t("filters.hasFileSignings"),
              column: 1,
              switch: {
                name: "has_file_signings",
                model: true,
              },
              method: () => {},
              checkbox: true,
              hoverBg: true,
            },
            {
              label: this.$t("filters.isArchived"),
              column: 1,
              switch: {
                name: "is_archived",
                model: true,
              },
              method: () => {},
              checkbox: true,
              hoverBg: true,
            },
            {
              label: this.$t("filters.hasFilePreviews"),
              column: 1,
              switch: {
                name: "has_file_previews",
                model: true,
              },
              method: () => {},
              checkbox: true,
              hoverBg: true,
            },
            {
              label: this.$t("filters.actionRequired"),
              column: 1,
              switch: {
                name: "action_required",
                model: true,
              },
              method: () => {},
              checkbox: true,
              hoverBg: true,
            },
            {
              label: this.$t("filters.withStatus"),
              column: 2,
              select: {
                name: "with_status",
                multiple: true,
                model: null,
                options: [],
                label: "label",
                placeholder: this.$t("placeholders.selectStatus"),
                wrap: true,
                searchable: true,
                searchChange: () => {},
              },
              method: () => {},
              checkbox: true,
              hoverBg: true,
              hideIfNoOptions: true,
            },
            {
              label: this.$t("filters.withoutStatus"),
              column: 3,
              select: {
                name: "without_status",
                multiple: true,
                model: null,
                options: [],
                label: "label",
                placeholder: this.$t("placeholders.selectStatus"),
                wrap: true,
                searchable: true,
                searchChange: () => {},
              },
              method: () => {},
              checkbox: true,
              hoverBg: true,
              hideIfNoOptions: true,
            },
            {
              label: this.$t("filters.withTemplate"),
              column: 2,
              select: {
                name: "with_template",
                multiple: true,
                model: [],
                options: [],
                label: "label",
                placeholder: this.$t("placeholders.selectTemplate"),
                wrap: true,
                searchable: true,
                searchChange: () => {},
              },
              method: () => {},
              checkbox: true,
              hoverBg: true,
              hideIfNoOptions: true,
            },
            {
              label: this.$t("filters.withoutTemplate"),
              column: 3,
              select: {
                name: "without_template",
                multiple: true,
                model: [],
                options: [],
                label: "label",
                placeholder: this.$t("placeholders.selectTemplate"),
                wrap: true,
                searchable: true,
                searchChange: () => {},
              },
              method: () => {},
              checkbox: true,
              hoverBg: true,
              hideIfNoOptions: true,
            },
            {
              label: this.$t("filters.withUser"),
              column: 2,
              select: {
                name: "with_user",
                multiple: true,
                model: [],
                options: [],
                label: "label",
                placeholder: this.$t("placeholders.selectUser"),
                wrap: true,
                searchable: true,
                internalSearch: true,
                searchChange: () => {},
              },
              method: () => {},
              checkbox: true,
              hoverBg: true,
              hideIfNoOptions: false,
            },
            {
              label: this.$t("filters.withoutUser"),
              column: 3,
              select: {
                name: "without_user",
                multiple: true,
                model: [],
                options: [],
                label: "label",
                placeholder: this.$t("placeholders.selectUser"),
                wrap: true,
                searchable: true,
                internalSearch: true,
                searchChange: () => {},
              },
              method: () => {},
              checkbox: true,
              hoverBg: true,
              hideIfNoOptions: false,
            },
            {
              label: this.$t("filters.withContact"),
              column: 2,
              select: {
                name: "with_contact",
                multiple: true,
                model: [],
                options: [],
                label: "label",
                placeholder: this.$t("placeholders.selectContact"),
                wrap: true,
                searchable: true,
                internalSearch: true,
                searchChange: () => {},
              },
              method: () => {},
              checkbox: true,
              hoverBg: true,
              hideIfNoOptions: false,
            },
            {
              label: this.$t("filters.withoutContact"),
              column: 3,
              select: {
                name: "without_contact",
                multiple: true,
                model: [],
                options: [],
                label: "label",
                placeholder: this.$t("placeholders.selectContact"),
                wrap: true,
                searchable: true,
                internalSearch: true,
                searchChange: () => {},
              },
              method: () => {},
              checkbox: true,
              hoverBg: true,
              hideIfNoOptions: false,
            },
            {
              label: this.$t("filters.withTags"),
              column: 2,
              select: {
                name: "with_tag",
                multiple: true,
                model: [],
                options: [],
                label: "label",
                placeholder: this.$t("placeholders.selectTag"),
                wrap: true,
                searchable: true,
                internalSearch: true,
                searchChange: () => {},
              },
              method: () => {},
              checkbox: true,
              hoverBg: true,
              hideIfNoOptions: false,
            },
            {
              label: this.$t("filters.withoutTags"),
              column: 3,
              select: {
                name: "without_tag",
                multiple: true,
                model: [],
                options: [],
                label: "label",
                placeholder: this.$t("placeholders.selectTag"),
                wrap: true,
                searchable: true,
                internalSearch: true,
                searchChange: () => {},
              },
              method: () => {},
              checkbox: true,
              hoverBg: true,
              hideIfNoOptions: false,
            },
            {
              label: this.$t("filters.hasCesDailyAbove"),
              column: 2,
              select: {
                name: "has_ces_daily_above",
                multiple: false,
                model: null,
                options: [],
                label: "label",
                placeholder: this.$t("placeholders.selectCesDaily"),
                wrap: true,
                searchable: true,
                searchChange: () => {},
              },
              method: () => {},
              checkbox: true,
              hoverBg: true,
              hideIfNoOptions: true,
            },
            {
              label: this.$t("filters.timeFilter"),
              filterGroup: "timeFilter",
              select: {
                name: "time_col",
                multiple: false,
                model: [],
                preselectModel: {
                  label: this.$t("filters.created_at"),
                  value: "created_at",
                },
                options: [],
                label: "label",
                placeholder: this.$t("placeholders.selectTimeColumn"),
                wrap: true,
                searchable: false,
                searchChange: () => {},
              },
              method: () => {},
              style: "width: 250px;",
              hideIfNoOptions: true,
            },
            {
              label: this.$t("filters.timeFilter"),
              filterGroup: "timeFilter",
              select: {
                name: "time_relative",
                multiple: false,
                model: [],
                preselectModel: {
                  label: this.$t("filters.timeRelative.today"),
                  value: "today",
                },
                options: [],
                label: "label",
                placeholder: this.$t("placeholders.selectTimeRelative"),
                wrap: true,
                searchable: false,
                searchChange: () => {},
              },
              style: "width: 250px;",
              method: () => {},
              hideIfNoOptions: true,
            },
            {
              label: this.$t("filters.timeFilter"),
              filterGroup: "timeFilter",
              conditional: {
                name: "time_relative",
                value: "custom",
              },
              dateTimeRange: {
                name: ["time_from", "time_to"],
                model: [],
                lang: "de",
                placeholder: "Placeholder",
              },
              method: () => {},
              hideIfNoOptions: true,
            },
            {
              label: this.$t("filters.activateFilter"),
              border: "border-top",
              color: "primary",
              position: "center",
              method: () => {
                this.setProjectsFilters();
              },
              noActiveState: true,
              button: true,
              multiColumnsBottomNav: true,
            },
            {
              label: this.$t("filters.resetFilter"),
              color: "text-danger",
              position: "center",
              method: () => {
                this.resetFilters(this.setProjectsFilters, "projects");
              },
              hoverBg: true,
              noActiveState: true,
              multiColumnsBottomNav: true,
            },
          ],
          groups: {
            timeFilter: {
              hoverBg: true,
              checkbox: true,
              method: () => {},
            },
          },
        },
      ],
    };
  },
};
